import React, { PropsWithChildren } from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: "rgba(0, 0, 0, .6)",
      fontSize: 13,
      [theme.breakpoints.up("md")]: {
        fontSize: 17,
      },
    },
  })
)
export default function SectionDescription({ children }: PropsWithChildren<{}>) {
  const classes = useStyles()
  return <Typography className={classes.root}>{children}</Typography>
}
